import { NumericFormat } from "react-number-format";

const CurrencyFormat = ({ value, className }) => {
  return (
    <NumericFormat
      className={className}
      displayType="text"
      value={value}
      thousandSeparator=","
      decimalScale={2}
      fixedDecimalScale
      prefix={"L "}
    />
  );
};

export default CurrencyFormat;
